import React from 'react';

import getConfig from '../../Util/Config';
import MaintenanceView from '../../Components/Maintenance';

const Maintenance = ({ ...props }) => {
  const { announcement } = getConfig();
  return <MaintenanceView announcement={announcement} />;
};

export default Maintenance;
